import { Fragment, useState } from "react";
import { Button } from "react-bootstrap";
import NewAddress from "../../../../modules/components/addresses/NewAddress";

export default function NewAddressDigikalaButton({ onSubmit = () => {} }) {
  const [showNewAddressModal, setShowNewAddressModal] = useState(false);

  return (
    <Fragment>
      <div className="w-100">
        <Button
          type="button"
          variant="outline-success"
          onClick={() => setShowNewAddressModal(true)}
        >
          ثبت آدرس جدید
        </Button>
      </div>

      {showNewAddressModal && (
        <NewAddress
          senderOrgetter={0}
          setResult={({ address }) => {
            onSubmit(address);
            setShowNewAddressModal(false);
          }}
          onClose={() => setShowNewAddressModal(false)}
        />
      )}
    </Fragment>
  );
}
